import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ShareDataService } from '../../../../shared/utils/share-data.service';

@Component({
  selector: 'app-dashboard-landing',
  templateUrl: './dashboard_landing.html',
  styleUrls: ['./dashboard_landing.scss'],
  standalone: true,
})
export class DashboardLandingComponent {
shareDataService = inject(ShareDataService);
      currentYear = new Date().getFullYear();

  constructor(private router: Router) {
   this.shareDataService.setData("Welcome")
  }

  navigateTo(route: string) {
    // You can adjust these routes as per your routing setup
    this.router.navigate([route]);
  }
}